import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { RouletteResult } from 'src/app/models/roulette.model';
import { HttpService } from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class MultiluckService {

    constructor(private httpService: HttpService) { }

    /**
     * Gets available games
     * @author Starley Cazorla
     * @param cpf
     * @returns
     */
    async getAvailabeGames(cpf: string) {
        let config = this.httpService.setHeaderConfig(true);
        return await lastValueFrom(this.httpService.get(UrlConnectionEnum.GET_AVAILABLE_GAMES, { cpf: cpf }, config));
    }

    /**
     * Gets list of games
     * @author Starley Cazorla
     * @param slug
     * @param cpf
     * @returns
     */
    async getListOfGames(slug: 'rifa' | 'presente' | 'raspadinha' | 'sorteio' | 'roleta', cpf: string) {
        let config = this.httpService.setHeaderConfig(true);
        return await lastValueFrom(this.httpService.get(UrlConnectionEnum.GET_LIST_GAMES_BY_SLUG, { slug: slug, cpf: cpf }, config))
    }

    /**
     * Gets list of scratch
     * @author Starley Cazorla
     * @param scrathData
     * @returns
     */
    async getListOfScratch(scrathData: any) {
        let config = this.httpService.setHeaderConfig(true);
        return await lastValueFrom(this.httpService.post(UrlConnectionEnum.RESCUE_SCRATCH_OFF, { slug: 'raspadinha', ...scrathData }, config))
    }

    /**
     * Gets list of raffle
     * @author Starley Cazorla
     * @param slug
     * @param cpf
     * @param id_jogo
     * @returns
     */
    async getListOfRaffle(slug: 'rifa', cpf: string, id_jogo: number) {
        let config = this.httpService.setHeaderConfig(true);
        return await lastValueFrom(this.httpService.get(UrlConnectionEnum.GET_NUMBER_OF_RAFFLE, { slug: slug, cpf: cpf, id_jogo: id_jogo }, config));
    }

    /**
     * Rescues raffle
     * @author Starley Cazorla
     * @param cpf
     * @param idowner
     * @param numberSelected
     * @returns
     */
    async rescueRaffle(cpf: string, idowner: number, numberSelected: any) {
        let config = this.httpService.setHeaderConfig(true);
        const payload = { slug: 'rifa', cpf: cpf, idowner: idowner, id_jogo: numberSelected.id_jogo, numero: numberSelected.numero_slot };
        return await lastValueFrom(this.httpService.post(UrlConnectionEnum.RESCUE_NUMBER_RAFFLE, payload, config));
    }

    /**
     * Rescues gift box by id jogo
     * @author Starley Cazorla
     * @param cpf
     * @param idowner
     * @param id_jogo
     * @returns
     */
    async rescueGiftBoxByIdJogo(cpf: string, idowner: number, id_jogo: number) {
        let config = this.httpService.setHeaderConfig(true);
        const payload = { slug: 'presente', cpf: cpf, idowner: idowner, id_jogo: id_jogo };
        return await lastValueFrom(this.httpService.post(UrlConnectionEnum.RESCUE_GIFT_BOX, payload, config));
    }

    /**
     * Saves rescue multiluck
     * @author Starley Cazorla
     * @param slug
     * @param rescueData
     * @returns
     */
    async saveRescueMultiluck(slug: 'rifa' | 'presente' | 'raspadinha', rescueData: any): Promise<any> {
        let config = this.httpService.setHeaderConfig(true);
        return await lastValueFrom(this.httpService.post(UrlConnectionEnum.SAVE_RESCUE_GIFT_BOX, { slug: slug, ...rescueData }, config));
    }

    /**
     * Gets lucky numbers
     * @author Starley Cazorla
     * @param params
     * @returns
     */
    async getLuckyNumbers(params: any) {
        let config = this.httpService.setHeaderConfig(true);
        return await lastValueFrom(this.httpService.get(UrlConnectionEnum.GET_LUCKY_NUMBERS, { ...params }, config));
    }

    /**
     * Gets game value
     * @author Starley Cazorla
     * @param params
     * @returns
     */
    async getGameValue(params: any) {
        let config = this.httpService.setHeaderConfig(true);
        return await lastValueFrom(this.httpService.get(UrlConnectionEnum.GET_VALUE_GAME, { ...params }, config));
    }

    /**
     * Rescues roulette
     * @author Starley Cazorla
     * @param cpf
     * @param idowner
     * @param id_jogo
     * @returns
     */
    async rescueRoulette(cpf: string, idowner: number, id_jogo: number): Promise<RouletteResult> {
        let config = this.httpService.setHeaderConfig(true);
        const payload = { slug: 'roleta', cpf: cpf, idowner: idowner, id_jogo: id_jogo };
        return await lastValueFrom(this.httpService.post(UrlConnectionEnum.RESCUE_ROULETTE, payload, config));
    }
}
